import React, { useContext } from 'react';
import { TextField } from 'office-ui-fabric-react';

import { Props } from './ModalInput.types';
import { Styled } from './ModalInput.styles';
import { useField, useFormikContext } from 'formik';

import { useBoolean } from 'hooks/useBoolean';
import FilterModal from 'views/components/Video/FilterModal';
import { context } from '../context';
import { toFilterModalItems } from 'utils/formatters';
import { FilterModalItem } from 'types/filters';
import { RouteFormValues } from '../Modes.types';

export const ModalInput: React.FC<Props> = ({ name, ...props }) => {
  const { values } = useFormikContext<Record<string, number[]>>();
  const [_, { value }, { setValue }] = useField<number[]>(name);
  const [showModal, toggleModal] = useBoolean();
  const { list } = useContext(context);

  const onFilter = (result: FilterModalItem[] | null) => {
    if (result) {
      setValue(result.map<number>(({ key }) => key as number));
    } else {
      setValue([]);
    }
  };

  const displayValue = list
    .filter(({ id }) => value.includes(id))
    .map((i) => i[name])
    .join(', ');

  const items = toFilterModalItems({
    items: list.filter(({ id }) => {
      let result = true;
      Object.values(values).forEach((value) => {
        if (value.length > 0 && !value.includes(id)) {
          result = false;
        }
      });
      return result;
    }),
    primaryField: name,
    key: 'id',
  });

  return (
    <>
      {showModal && (
        <FilterModal
          title={name}
          allFilters={null}
          onCloseModal={toggleModal}
          onFilter={onFilter}
          selectedFilters={{
            [name]: value,
          }}
          items={items}
          viewTitle={props.label || ''}
        />
      )}
      <TextField
        {...props}
        value={displayValue}
        onClick={toggleModal}
        readOnly
      />
    </>
  );
};
